
import React from 'react';
import { Job } from "@/components/jobs/types";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface JobSalaryFieldsProps {
  job: Pick<Job, 'salary_min' | 'salary_max' | 'salary'>;
  isEditing: boolean;
  formDataSalaryMin: string | number;
  formDataSalaryMax: string | number;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const formatSalaryDisplay = (min?: number | null, max?: number | null, salaryText?: string | null): string => {
  const formatCurrency = (val: number) => val.toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 });

  if (min != null && max != null) {
    return `${formatCurrency(min)} - ${formatCurrency(max)}`;
  }
  if (min != null) {
    return `From ${formatCurrency(min)}`;
  }
  if (max != null) {
    return `Up to ${formatCurrency(max)}`;
  }
  if (salaryText) return salaryText;
  return 'N/A';
};

export const JobSalaryFields: React.FC<JobSalaryFieldsProps> = ({ job, isEditing, formDataSalaryMin, formDataSalaryMax, onInputChange }) => {
  return (
    <>
      {isEditing ? (
        <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
          <div>
            <Label htmlFor="salary_min" className="text-xs font-medium text-muted-foreground">Salary Minimum</Label>
            <Input
              id="salary_min"
              name="salary_min"
              type="number"
              value={formDataSalaryMin}
              onChange={onInputChange}
              placeholder="e.g. 80000"
              className="text-sm"
              min="0"
            />
          </div>
          <div>
            <Label htmlFor="salary_max" className="text-xs font-medium text-muted-foreground">Salary Maximum</Label>
            <Input
              id="salary_max"
              name="salary_max"
              type="number"
              value={formDataSalaryMax}
              onChange={onInputChange}
              placeholder="e.g. 120000"
              className="text-sm"
              min="0"
            />
          </div>
        </div>
      ) : (
        <div className="md:col-span-2">
          <Label className="text-xs font-medium text-muted-foreground">Salary</Label>
          <p>{formatSalaryDisplay(job.salary_min, job.salary_max, job.salary)}</p>
        </div>
      )}
    </>
  );
};
